<article class="tw-flex tw-flex-col tw-gap-5 {{articleClassName}}">
  <span class="tw-self-center tw-font-bold tw-text-xl" [mhTooltip]="tooltip">{{title}}</span>
  <section class="{{heightClass}} tw-rounded-lg tw-shadow-1 {{className}}">
    <ng-content></ng-content>
  </section>
</article>

